// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateAgentMarketingProfileSocialAccounts(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AgentMarketingProfileSocialAccountsUpdated"]);
}

let variablesConverter = {"marketingProfileSocialAccountsInput":{},"updateAgentMarketingProfileSocialAccountsInput":{"socialAccounts":{"r":"marketingProfileSocialAccountsInput"}},"__root":{"input":{"r":"updateAgentMarketingProfileSocialAccountsInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateAgentMarketingProfileSocialAccounts_AgentMarketingProfileSocialAccountsUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileSocialAccounts":{"u":"response_updateAgentMarketingProfileSocialAccounts"}}};

let wrapResponseConverterMap = {
  response_updateAgentMarketingProfileSocialAccounts: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateAgentMarketingProfileSocialAccounts_AgentMarketingProfileSocialAccountsUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileSocialAccounts":{"u":"response_updateAgentMarketingProfileSocialAccounts"}}};

let responseConverterMap = {
  response_updateAgentMarketingProfileSocialAccounts: unwrap_response_updateAgentMarketingProfileSocialAccounts
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentMarketingProfileSocialAccountsSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileSocialAccounts",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentMarketingProfileSocialAccountsSettings_form_agentMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileSocialAccountsUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentMarketingProfileSocialAccountsSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileSocialAccounts",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MarketingProfileSocialAccounts",
                    "kind": "LinkedField",
                    "name": "socialAccounts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "twitter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "facebook",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "instagram",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "linkedIn",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "youTube",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tikTok",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "yelp",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileSocialAccountsUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5772bdd4d7a9109dd9a533c033c9cdf0",
    "id": null,
    "metadata": {},
    "name": "AgentMarketingProfileSocialAccountsSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation AgentMarketingProfileSocialAccountsSettingsMutation(\n  $input: UpdateAgentMarketingProfileSocialAccountsInput!\n) {\n  updateAgentMarketingProfileSocialAccounts(input: $input) {\n    __typename\n    ... on AgentMarketingProfileSocialAccountsUpdated {\n      marketingProfile {\n        ...AgentMarketingProfileSocialAccountsSettings_form_agentMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentMarketingProfileSocialAccountsSettings_form_agentMarketingProfile on AgentMarketingProfile {\n  socialAccounts {\n    twitter\n    facebook\n    instagram\n    linkedIn\n    youTube\n    tikTok\n    yelp\n  }\n  publicUrl\n}\n"
  }
};
})());

let wrap_response_updateAgentMarketingProfileSocialAccounts = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentMarketingProfileSocialAccounts = unwrap_response_updateAgentMarketingProfileSocialAccounts;
exports.wrap_response_updateAgentMarketingProfileSocialAccounts = wrap_response_updateAgentMarketingProfileSocialAccounts;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
